import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"
import { router } from "@inertiajs/react"

export interface PagyMeta {
  page: number
  last: number
  count: number
  from: number
  to: number
  prev: number | null
  next: number | null
}

function buildUrl(page: number) {
  const url = new URL(window.location.href)
  url.searchParams.set("page", String(page))
  return url.pathname + url.search
}

function pageNumbers(current: number, last: number): (number | "ellipsis")[] {
  const pages: (number | "ellipsis")[] = []
  if (last <= 7) {
    for (let i = 1; i <= last; i++) pages.push(i)
    return pages
  }

  pages.push(1)
  if (current > 3) pages.push("ellipsis")

  const start = Math.max(2, current - 1)
  const end = Math.min(last - 1, current + 1)
  for (let i = start; i <= end; i++) pages.push(i)

  if (current < last - 2) pages.push("ellipsis")
  pages.push(last)
  return pages
}

export function PagyPagination({ pagy }: { pagy: PagyMeta }) {
  if (pagy.last <= 1) return null

  function navigate(page: number) {
    router.visit(buildUrl(page), { preserveState: true, preserveScroll: true })
  }

  return (
    <div className="flex flex-col items-center justify-between gap-3 py-4 sm:flex-row">
      <p className="text-muted-foreground text-sm">
        Showing{" "}
        <span className="text-foreground font-medium">
          {pagy.from}&ndash;{pagy.to}
        </span>{" "}
        of <span className="text-foreground font-medium">{pagy.count}</span>
      </p>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              onClick={(e) => {
                e.preventDefault()
                if (pagy.prev) navigate(pagy.prev)
              }}
              className={!pagy.prev ? "pointer-events-none opacity-50" : "cursor-pointer"}
              href="#"
            />
          </PaginationItem>
          {pageNumbers(pagy.page, pagy.last).map((p, i) =>
            p === "ellipsis" ? (
              <PaginationItem key={`ellipsis-${i}`}>
                <PaginationEllipsis />
              </PaginationItem>
            ) : (
              <PaginationItem key={p}>
                <PaginationLink
                  isActive={p === pagy.page}
                  onClick={(e) => {
                    e.preventDefault()
                    navigate(p)
                  }}
                  href="#"
                  className="cursor-pointer"
                >
                  {p}
                </PaginationLink>
              </PaginationItem>
            ),
          )}
          <PaginationItem>
            <PaginationNext
              onClick={(e) => {
                e.preventDefault()
                if (pagy.next) navigate(pagy.next)
              }}
              className={!pagy.next ? "pointer-events-none opacity-50" : "cursor-pointer"}
              href="#"
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )
}
